import { render } from "./AddAddressModal.vue?vue&type=template&id=0b13c4d9&scoped=true"
import script from "./AddAddressModal.vue?vue&type=script&lang=js"
export * from "./AddAddressModal.vue?vue&type=script&lang=js"

import "./AddAddressModal.vue?vue&type=style&index=0&id=0b13c4d9&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b13c4d9"]])

export default __exports__